export interface SymbolLibraryAvailabilityAsset {
  tab: string;
  category: string;
  label: string;
  legacyType?: string;
}

const DISABLED_IN_3D_LEGACY_TYPES = new Set([
  "Door",
  "SlidingDoor",
  "GlassSlidingDoor",
  "DoubleDoor",
  "Window",
  "Void",
]);

export const isSymbolLibraryTabDisabledIn3D = (tab: string) => tab === "ELEVATION";

export const isSymbolLibraryAssetDisabledIn3D = (asset: SymbolLibraryAvailabilityAsset) => {
  if (isSymbolLibraryTabDisabledIn3D(asset.tab)) {
    return true;
  }

  if (DISABLED_IN_3D_LEGACY_TYPES.has(asset.legacyType ?? "")) {
    return true;
  }

  if (asset.category !== "Wall Attachments") {
    return false;
  }

  const label = asset.label.toLowerCase();
  return (
    label.startsWith("door") ||
    label.startsWith("glass sliding") ||
    label.startsWith("sliding door") ||
    label.startsWith("window") ||
    label === "void"
  );
};
